<template>
  <div class="agreement-container margin-top-12">
    <div
      :class="['grid-row gap-16 mt-1', idx > 0 ? 'border' : '']"
      v-for="(item, idx) in agreementOrders"
      :key="idx"
    >
      <div v-if="!hideTitle" class="sac__font-18 med mt-3">
        Order {{ idx + 1 }} of {{ agreementOrders.length }}
      </div>
      <div v-if="idx === 0" class="flex-row align-center">
        <div class="flex-1">
          <SACCheckbox
            :checked="newAgreement.platformFee"
            field="platformFee"
            label="Add Monthly Platform Fee"
            :change="() => onChangeAgreement('platformFee', !newAgreement.platformFee)"
          />
        </div>
        <div v-if="newAgreement.platformFee" class="flex-1 grid-row gap-10">
          <div class="flex-row align-center input-background">
            <div class="i-price-dollar">$</div>
            <SACInput
              type="number"
              field="platformFeeAmount"
              placeholder="$"
              :value="newAgreement.platformFeeAmount"
              :change="(f, v) => onChangeAgreement(f, v)"
            />
          </div>
        </div>
      </div>
      <div v-if="idx === 0" class="flex-row align-end">
        <div class="flex-1 margin-bottom-8">
          <SACCheckbox
            :checked="newAgreement.connectFee"
            field="connectFee"
            label="Add Connect Subscription"
            :change="() => onChangeAgreement('connectFee', !newAgreement.connectFee)"
          />
        </div>
        <div v-if="newAgreement.connectFee" class="flex-1 margin-left-16">
          <div class="sac__font-14">Connect Product</div>
          <SACDropdown
            field="connectProduct"
            placeholder="Amount"
            :value="newAgreement.connectProduct"
            :options="connectPlans"
            :change="onChangeAgreement"
          />
        </div>
        <div v-if="newAgreement.connectFee" class="flex-1 flex-column margin-left-16">
          <div class="sac__font-14">Number of Free Connect Users</div>
          <SACInput
            type="number"
            field="connectFreeUsers"
            placeholder="Free Connect Users"
            :value="newAgreement.connectFreeUsers"
            :change="onChangeAgreement"
          />
        </div>
      </div>
      <div v-if="idx === 0" class="flex-row align-center">
        <div class="flex-1">
          <SACCheckbox
            :checked="newAgreement.gen2Preorder"
            field="gen2Preorder"
            label="Add Gen2 Preorder"
            :change="() => onChangeAgreement('gen2Preorder', !newAgreement.gen2Preorder)"
          />
        </div>
      </div>
      <div>
        <div class="ao-table-header sac__font-14">
          <div>Product</div>
          <div>Product version</div>
          <div>Vendor</div>
          <div>Price</div>
          <div>Quantity</div>
          <div>Total</div>
          <div />
        </div>
        <div
          v-for="(order, i) in item.agreementOrderLines"
          :key="i"
          class="ao-table-body"
        >
          <div class="grid-row gap-10">
            <SACDropdown
              field="productId"
              placeholder="Select product"
              :options="i === 0 ? plans : extraPlans"
              :value="order.productId"
              :change="(f, v) => changeOrderItem(f, v, idx, i)"
            />
          </div>
          <div class="grid-row gap-10">
            <SACDropdown
              v-if="showProductSkus(order.productId)"
              field="version"
              placeholder="Select version"
              :options="versionOptions"
              :value="order.version"
              :change="(f, v) => changeOrderItem(f, v, idx, i)"
            />
          </div>
          <div class="grid-row gap-10">
            <SACDropdown
              field="vendor"
              placeholder="Select vendor"
              :options="vendorOptions"
              :value="order.vendor"
              :change="(f, v) => changeOrderItem(f, v, idx, i)"
            />
          </div>
          <div class="grid-row gap-10">
            <div class="flex-row align-center input-background">
              <div class="i-price-dollar">$</div>
              <SACInput
                type="number"
                field="price"
                placeholder="$"
                :value="order.price"
                :change="(f, v) => changeOrderItem(f, v, idx, i)"
                :disable="i === 0"
              />
            </div>
          </div>
          <div class="grid-row gap-10">
            <SACInput
              type="number"
              field="quantity"
              placeholder="0"
              :value="order.quantity"
              :change="(f, v) => changeOrderItem(f, v, idx, i)"
            />
          </div>
          <div class="match-input">${{ getNumberLocale(order.total) }}</div>
          <button v-if="i > 0" type="button" @click="removeOrder(idx, i)">
            <img
              src="@shared/assets/img/general/trash-red.svg"
              class="img-size-16 clickable"
              alt="remove"
            />
          </button>
        </div>
      </div>
      <div class="flex-row align-center justify-end">
        <button type="button" class="sac__button bg-primary" @click="addLineItem(idx)">
          Add line item +
        </button>
      </div>
      <div class="grid-row gap-10">
        <div class="sac__font-14">Shipping/Branch Address</div>
        <SACDropdown
          field="shippingAddressId"
          placeholder="Select Address"
          :options="addressOptions"
          :value="item.shippingAddressId"
          :change="(f, v) => changeAgreement(f, v, idx)"
        />
      </div>
      <div class="grid-column ai-s gap-16">
        <div class="grid-row gap-10">
          <div class="sac__font-14">PO Number (optional)</div>
          <div class="max-width">
            <SACInput
              field="customerPo"
              placeholder="0"
              :value="item.customerPo"
              :change="(f, v) => changeAgreement(f, v, idx)"
            />
          </div>
        </div>
        <div class="grid-row gap-10">
          <div class="sac__font-14">Shipping fee</div>
          <div class="max-width">
            <div class="flex-row align-center input-background">
              <div class="i-price-dollar">$</div>
              <SACInput
                type="number"
                field="shippingCost"
                :value="item.shippingCost"
                :change="(f, v) => changeAgreement(f, v, idx)"
              />
            </div>
          </div>
        </div>
        <div class="grid-row gap-10">
          <div class="sac__font-14">Planned ship date</div>
          <div class="max-width">
            <DatePicker
              :value="item.plannedStartDate"
              :min-date="new Date()"
              @input="(v) => changeAgreement('plannedStartDate', v, idx)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import SACDropdown from "@shared/components/sac/SACDropdown.vue";
import SACInput from "@shared/components/sac/SACInput.vue";
import SACCheckbox from "@shared/components/sac/SACCheckbox.vue";
import DatePicker from "@shared/components/DatePicker.vue";
import partnerAgreementMixin from "@shared/mixins/partnerAgreementMixin";

export default {
  name: "AgreementOrder",
  components: {
    SACInput,
    SACDropdown,
    SACCheckbox,
    DatePicker,
  },
  mixins: [partnerAgreementMixin],
  props: {
    hideTitle: Boolean,
  },
  data() {
    return {
      versionOptions: [
        {
          label: "V1",
          value: "v1",
        },
        {
          label: "V2",
          value: "v2",
        },
      ],
      vendorOptions: [
        {
          label: "SmartAC",
          value: "SmartAC",
        },
        {
          label: "OMNI",
          value: "OMNI",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      allBranchAddresses: (state) => state.partnerDetail.allBranchAddresses,
    }),
    plans() {
      return this.products
        .filter((p) => p.sku.endsWith("PM"))
        .map((p) => ({
          label: `${p.itemName} ($${p.price})`,
          value: p.id,
        }));
    },
    connectPlans() {
      return this.products
        .filter((p) => p.sku.includes("CNX"))
        .map((p) => ({
          label: `${p.itemName} ($${p.price})`,
          value: p.id,
        }));
    },
    extraPlans() {
      return this.products
        .filter(
          (p) =>
            p.itemClass?.toLowerCase() !== "subscription" &&
            p.type?.toLowerCase() !== "shipping"
        )
        .map((p) => ({
          label: `${p.itemName} ($${p.price})`,
          value: p.id,
        }));
    },
    addressOptions() {
      return this.allBranchAddresses.map((ad) => {
        const { company, address1, address2, city, state, zip } = ad;
        const label = `${company}: ${address1}${
          address2 ? ` ${address2}` : ""
        }, ${city}, ${state} ${zip}`;
        return {
          label,
          value: ad.id,
        };
      });
    },
  },
  methods: {
    isValidDateFormat(date) {
      // Format - 'MM/DD/YY'
      if (date) {
        const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
        return regex.test(date) ? null : "Date format is not valid";
      }
      return null;
    },
    changeProduct(updateItem, id) {
      const product = this.products.find((p) => p.id === id);
      updateItem.productId = id;
      updateItem.price = product.price;
      updateItem.total = product.price;
      updateItem.quantity = 1;
      updateItem.itemName = product.itemName;
      if (
        product?.category?.toLowerCase() === "subscriptions" ||
        product?.category?.toLowerCase() === "membership"
      ) {
        updateItem.subscriptionPlanId = product.priceId;
      }
    },
    changeQuantity(updateItem, value) {
      const { price } = updateItem;
      let q = Number(value.replace(",", ""));
      if (q > 9999) {
        q = 0;
      }
      updateItem.quantity = q;
      updateItem.total = price * q;
    },
    formatShipDate(date) {
      let nValue = date;
      const value = date.replace(/\D/g, "");
      if (value.length <= 2) {
        nValue = value;
      } else if (value.length <= 4) {
        nValue = `${value.slice(0, 2)}/${value.slice(2)}`;
      } else {
        nValue = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
      }
      return nValue;
    },
    changeOrderItem(f, v, agreementIdx, orderIdx) {
      const agreement = { ...this.agreementOrders[agreementIdx] };
      const agreementOrderLines = [...agreement.agreementOrderLines];
      const updateOrderItem = { ...agreementOrderLines[orderIdx] };
      if (f === "productId") {
        this.changeProduct(updateOrderItem, v);
      } else if (f === "quantity") {
        this.changeQuantity(updateOrderItem, v);
      } else if (f === "price") {
        updateOrderItem.price = v;
        updateOrderItem.total = v * updateOrderItem.quantity;
      } else {
        updateOrderItem[f] = v;
      }
      agreementOrderLines[orderIdx] = updateOrderItem;
      agreement.agreementOrderLines = agreementOrderLines;
      const updatedAgreementList = this.agreementOrders.map((item, idx) => {
        if (idx === agreementIdx) {
          return agreement;
        }
        return item;
      });
      this.onChangeAgreement("agreementOrders", updatedAgreementList);
    },
    changeAgreement(f, v, agreementIdx) {
      const updatedAgreementList = this.agreementOrders.map((item, idx) => {
        if (idx === agreementIdx) {
          return {
            ...item,
            [f]: v,
          };
        }
        return item;
      });
      this.onChangeAgreement("agreementOrders", updatedAgreementList);
    },
    removeOrder(agreementIdx, orderIdx) {
      const updatedAgreementList = this.agreementOrders.map((item, idx) => {
        if (idx === agreementIdx) {
          return {
            ...item,
            agreementOrderLines: item.agreementOrderLines.filter(
              (_, i) => orderIdx !== i
            ),
          };
        }
        return item;
      });
      this.onChangeAgreement("agreementOrders", updatedAgreementList);
    },
    addLineItem(agreementIdx) {
      const agreement = { ...this.agreementOrders[agreementIdx] };
      const { agreementOrderLines } = agreement;
      agreement.agreementOrderLines = [
        ...agreementOrderLines,
        {
          productId: 0,
          quantity: 0,
          total: 0,
        },
      ];
      const updatedAgreementList = this.agreementOrders.map((item, idx) => {
        if (idx === agreementIdx) {
          return agreement;
        }
        return item;
      });
      this.onChangeAgreement("agreementOrders", updatedAgreementList);
    },
    showProductSkus(productId) {
      let showProductSkus = false;
      const product = this.products.find((p) => p.id === productId);
      if (
        product?.sku.includes("PM") ||
        (product?.sku.includes("CS") && product?.category === "Sensors") ||
        (product?.sku.includes("FS") && product?.category === "Sensors") ||
        (product?.sku.includes("WS") && product?.category === "Sensors")
      ) {
        showProductSkus = true;
      }
      return showProductSkus;
    },
  },
};
</script>
<style scoped lang="scss">
.agreement-container {
  display: grid;
  gap: 1rem;

  .border {
    border-top: 0.7px solid $LIGHTBLUE;
  }

  .ao-table-header {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 0.5fr 0.5fr 0.3fr 0.3fr 0.3fr 0.1fr;
  }

  .ao-table-body {
    margin-top: 8px;
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 0.5fr 0.5fr 0.3fr 0.3fr 0.3fr 0.1fr;
  }

  .max-width {
    width: 300px;
  }

  .match-input,
  .date-picker-container {
    background-color: $NBLUE5;
    border-radius: 6px;
    height: 44px;
    width: 100%;
    display: grid;
    padding: 0 12px;
    align-items: center;
  }

  .input-background {
    background-color: $NBLUE5;
    padding-left: 8px;
  }
}
</style>
